import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import {
  allStepsCompleted,
  handleReset,
} from "../../redux/slices/addNewContentStepsSlice";
import { steps } from "../../constants";
import { StepLabel } from "@mui/material";
import { useParams } from "react-router-dom";
import { generateClient } from "aws-amplify/api";
import { getAgreement } from "../../graphql/queries";
import CircularProgress from "@mui/material/CircularProgress";
import { setAgreementDetails } from "../../redux/slices/agreementFormSlice";
import { toast } from "react-toastify";
import { handleCompleteStep } from "../../redux/slices/addNewContentStepsSlice";
import NavigationWarningModal from "../NavigationWarningModal";

export default function EditAgreementStepper() {
  const { agreementId } = useParams();
  const activeStep = useSelector(
    (state) => state.addNewContentSteps.activeStep
  );
  const completed = useSelector((state) => state.addNewContentSteps.completed);
  const dispatch = useDispatch();
  const [isLoading, setLoading] = React.useState(true);
  const [error, setError] = React.useState("");

  const renderStepContent = (activeStep) => {
    const renderStep = steps.find(
      (step, stepIndex) => stepIndex === activeStep
    );

    if (renderStep) {
      return renderStep?.component;
    } else {
      return <Typography>Not Found 404</Typography>;
    }
  };
  const client = generateClient();

  React.useEffect(() => {
    const fetchAgreement = async () => {
      try {
        setLoading(true);
        const response = await client.graphql({
          query: getAgreement,
          variables: { id: agreementId },
        });
        dispatch(setAgreementDetails(response.data.getAgreement));
      } catch (error) {
        console.error("Error fetching agreement:", error);
        toast.error("Error fetching agreement details");
        setError("Error fetching agreement details");
      } finally {
        setLoading(false);
      }
    };

    fetchAgreement();
  }, [agreementId, dispatch]);

  if (error) return <Typography color="error">{error}</Typography>;

  return (
    <>
      <NavigationWarningModal />
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ width: "100%" }}>
          <Stepper nonLinear activeStep={activeStep} alternativeLabel>
            {steps.map((step, index) => (
              <Step key={index} completed={completed[index]}>
                <StepButton color="secondary" disabled>
                  <StepLabel>{step.label}</StepLabel>
                </StepButton>
              </Step>
            ))}
          </Stepper>
          <div>
            {allStepsCompleted(steps) ? (
              <React.Fragment>
                <Typography sx={{ mt: 2, mb: 1 }}>
                  All steps completed - you&apos;re finished
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button onClick={() => dispatch(handleReset())}>Reset</Button>
                </Box>
              </React.Fragment>
            ) : (
              <React.Fragment>{renderStepContent(activeStep)}</React.Fragment>
            )}
          </div>
        </Box>
      )}
    </>
  );
}
